import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  public uploadImageSuccess: EventEmitter<any> = new EventEmitter();
  public selectedImageSuccess: EventEmitter<any> = new EventEmitter();
  public scanQrSuccess: EventEmitter<any> = new EventEmitter();
  public onPointSubscribe: EventEmitter<any> = new EventEmitter();
  public onProfileImgSubscribe: EventEmitter<any> = new EventEmitter();
  public onNotificationCount: EventEmitter<any> = new EventEmitter();
  public onMrkpNavs: EventEmitter<any> = new EventEmitter();
  public onMkpCatagory: EventEmitter<any> = new EventEmitter();
  public onReloadMyProfile: EventEmitter<any> = new EventEmitter();
  public onServiceClick: EventEmitter<any> = new EventEmitter();
  public onSwichPage: EventEmitter<any> = new EventEmitter();
  public onMenuClick: EventEmitter<any> = new EventEmitter();
  public onGotoMyStore: EventEmitter<any> = new EventEmitter();
  public onActivityFilter: EventEmitter<any> = new EventEmitter();
  public onNewsFilter: EventEmitter<any> = new EventEmitter();
  public onContentFilter: EventEmitter<any> = new EventEmitter();
  public onRewardFilter: EventEmitter<any> = new EventEmitter();
  public onStoreFilter: EventEmitter<any> = new EventEmitter();
  public onMyStoreFilter: EventEmitter<any> = new EventEmitter();
  public onMarketHomeFilter: EventEmitter<any> = new EventEmitter();
  public onMkpCatagoryReloadByPaging: EventEmitter<any> = new EventEmitter();
  public onPointModalEvent: EventEmitter<any> = new EventEmitter();
  public onCommentModalEvent: EventEmitter<any> = new EventEmitter();
  public onSelectFriendModalEvent: EventEmitter<any> = new EventEmitter();
  public onSurveyCatagory: EventEmitter<any> = new EventEmitter();
  constructor() { }
}
